import { invalidateCurrentUser } from '@/hooks/query/useQueryUser';
import { useMutateSubmitSalesBookingForm as useMutateSubmitSalesBookingFormCore } from '@heidi/workspace/data';

export type {
  SalesBookingFormName,
  SalesBookingSubmissionRequest,
  SalesBookingSubmissionResponse,
  UseMutateSubmitSalesBookingFormVariables,
} from '@heidi/workspace/data';

export function useMutateSubmitSalesBookingForm() {
  return useMutateSubmitSalesBookingFormCore({
    onSettled: async () => {
      await invalidateCurrentUser();
    },
  });
}
